import LabeledMonthPicker from './labeledMonthPicker';
import PropTypes from 'prop-types';
import React from 'react';

const handleMonthChange = ( props, name ) => event => {

    props.onChange( props, name, event );

};

const LabeledMonthRange = props => (

    <div>
        <div className="inner-rows">
            <LabeledMonthPicker
                className={props.className}
                name="buildMonth"
                label="From"
                selected={props.from}
                dateFormat={props.dateFormat}
                onChange={handleMonthChange( props, 'from' )}
                maxDate={new Date()}
            />
        </div>
        <div className="inner-rows">
            <LabeledMonthPicker
                className={props.className}
                name="buildMonth"
                label="To"
                selected={props.to}
                dateFormat={props.dateFormat}
                onChange={handleMonthChange( props, 'to' )}
                minDate={props.from !== null ? props.from : new Date()}
                maxDate={new Date()}
            />
        </div>
    </div>

);
LabeledMonthRange.displayName = 'LabeledMonthRange';
LabeledMonthRange.propTypes = {
    name: PropTypes.string.isRequired,
    from: PropTypes.number.isRequired,
    to: PropTypes.number.isRequired,
    className: PropTypes.string.isRequired,
    dateFormat: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};
export default LabeledMonthRange;
